// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Smart-home catalog — Al-Shiraa blue/gold system */

.shop-page {
  padding-top: 70px;
  min-height: 100vh;
  background:
    linear-gradient(180deg, #edf2f7 0%, var(--bg-white) 28%, var(--bg-white) 100%);
}

.shop-hero {
  padding: 3.25rem 0 2rem;
}

.shop-hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(240px, 0.7fr);
  gap: 2rem;
  align-items: end;
}

.shop-kicker {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--secondary-gold);
  margin-bottom: 0.65rem;
}

.shop-brand {
  font-size: clamp(2rem, 4.5vw, 3rem);
  font-weight: 700;
  color: var(--primary-dark-blue);
  line-height: 1.2;
  margin-bottom: 0.85rem;
}

.shop-lead {
  font-size: 1.05rem;
  color: var(--text-medium-gray);
  max-width: 38rem;
  margin-bottom: 1.35rem;
  line-height: 1.7;
}

.shop-hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
  margin-bottom: 0.85rem;
}

.shop-note {
  font-size: 0.88rem;
  color: var(--text-medium-gray);
}

.shop-hero-stats {
  display: grid;
  gap: 0.75rem;
  padding: 1.25rem;
  border: 1px solid var(--border-light);
  background: var(--bg-white);
  border-radius: 12px;
}

.shop-hero-stats div {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding-bottom: 0.65rem;
  border-bottom: 1px solid var(--border-light);
}

.shop-hero-stats div:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.shop-hero-stats strong {
  font-size: 1.75rem;
  color: var(--primary-dark-blue);
  line-height: 1;
}

.shop-hero-stats span {
  font-size: 0.85rem;
  color: var(--text-medium-gray);
}

.shop-wa-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0.7rem 1.25rem;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.98rem;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
  border: 2px solid transparent;
}

.shop-wa-btn--primary {
  background: #128c7e;
  color: #fff;
}

.shop-wa-btn--primary:hover {
  background: #0f766e;
  color: #fff;
  transform: translateY(-1px);
}

.shop-wa-btn--ghost {
  background: transparent;
  color: var(--primary-blue);
  border-color: var(--border-light);
}

.shop-wa-btn--card {
  width: 100%;
  background: #128c7e;
  color: #fff;
  margin-top: auto;
}

.shop-wa-btn--card:hover {
  background: #0f766e;
  color: #fff;
}

.shop-toolbar {
  position: sticky;
  top: 70px;
  z-index: 20;
  padding: 0.75rem 0 1rem;
  background: color-mix(in srgb, var(--bg-white) 94%, transparent);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-light);
}

.shop-toolbar-inner {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.shop-filters,
.shop-status-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  align-items: center;
}

.shop-chip,
.shop-status {
  border: 1px solid var(--border-light);
  background: var(--section-light-gray);
  color: var(--text-dark-gray);
  border-radius: 999px;
  padding: 0.4rem 0.85rem;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.shop-chip.is-active,
.shop-status.is-active {
  background: var(--primary-dark-blue);
  border-color: var(--primary-dark-blue);
  color: #fff;
}

.dark-mode .shop-chip.is-active,
.dark-mode .shop-status.is-active {
  background: var(--accent-blue);
  border-color: var(--accent-blue);
}

.shop-search {
  margin-inline-start: auto;
  flex: 1 1 220px;
  max-width: 340px;
}

.shop-search input {
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--border-light);
  border-radius: 10px;
  padding: 0.55rem 0.9rem;
  font-family: inherit;
  font-size: 0.95rem;
  background: var(--bg-white);
  color: var(--text-dark-gray);
}

.shop-grid-section {
  padding: 1.5rem 0 3.5rem;
}

.shop-result-count {
  font-size: 0.9rem;
  color: var(--text-medium-gray);
  margin-bottom: 1rem;
}

.shop-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 1.2rem;
}

.shop-card {
  display: flex;
  flex-direction: column;
  background: var(--bg-white);
  border: 1px solid var(--border-light);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 24px var(--shadow-color);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.shop-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 34px var(--shadow-color);
}

.shop-card-media {
  position: relative;
  aspect-ratio: 1;
  background: #f1f5f9;
  overflow: hidden;
}

.shop-card-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shop-badge {
  position: absolute;
  top: 0.7rem;
  inset-inline-start: 0.7rem;
  max-width: calc(100% - 1.4rem);
  background: rgba(26, 54, 93, 0.92);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.28rem 0.55rem;
  border-radius: 6px;
  line-height: 1.35;
}

.shop-card--requested .shop-badge {
  background: rgba(180, 120, 20, 0.95);
  color: #1a202c;
}

.shop-card--inquiry .shop-badge {
  background: rgba(74, 85, 104, 0.92);
}

.shop-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem 1rem 1.15rem;
  flex: 1;
}

.shop-card-meta {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;
}

.shop-card-vendor {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--secondary-gold);
  letter-spacing: 0.02em;
}

.shop-card-status {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  background: var(--section-light-gray);
  color: var(--text-medium-gray);
  white-space: nowrap;
}

.shop-card-status--pi {
  background: #dcfce7;
  color: #166534;
}

.shop-card-status--requested {
  background: #fef3c7;
  color: #92400e;
}

.shop-card-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--primary-dark-blue);
  line-height: 1.35;
}

.shop-card-model {
  font-size: 0.82rem;
  font-family: ui-monospace, Consolas, monospace;
  color: var(--text-medium-gray);
  direction: ltr;
  text-align: start;
}

.shop-card-qty {
  font-size: 0.84rem;
  font-weight: 700;
  color: var(--primary-blue);
}

.shop-card-blurb {
  font-size: 0.88rem;
  color: var(--text-medium-gray);
  line-height: 1.55;
  flex: 1;
}

.shop-protocols {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin: 0.25rem 0 0.7rem;
  padding: 0;
}

.shop-protocols li {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.45rem;
  border-radius: 5px;
  background: var(--section-light-gray);
  color: var(--primary-blue);
  border: 1px solid var(--border-light);
}

.shop-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--text-medium-gray);
}

.shop-cta {
  padding: 2.75rem 0 4rem;
  background: var(--gradient-primary);
  color: #fff;
}

.shop-cta-inner {
  text-align: center;
  max-width: 560px;
  margin: 0 auto;
}

.shop-cta h2 {
  font-size: 1.6rem;
  margin-bottom: 0.65rem;
}

.shop-cta p {
  opacity: 0.95;
  margin-bottom: 1.35rem;
}

.shop-cta .shop-wa-btn--primary {
  background: #fff;
  color: #0f766e;
}

.shop-cta .shop-wa-btn--primary:hover {
  background: #f0fdfa;
  color: #0f766e;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 860px) {
  .shop-hero-grid {
    grid-template-columns: 1fr;
  }

  .shop-search {
    margin-inline-start: 0;
    max-width: none;
    flex-basis: 100%;
  }
}

@media (max-width: 640px) {
  .shop-toolbar {
    top: 60px;
  }

  .shop-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShopPage.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,iBAAiB;EACjB,iBAAiB;EACjB;kFACgF;AAClF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6EAA6E;EAC7E,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gEAAgE;EAChE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;EAC5B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;EAC9B,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Smart-home catalog — Al-Shiraa blue/gold system */\n\n.shop-page {\n  padding-top: 70px;\n  min-height: 100vh;\n  background:\n    linear-gradient(180deg, #edf2f7 0%, var(--bg-white) 28%, var(--bg-white) 100%);\n}\n\n.shop-hero {\n  padding: 3.25rem 0 2rem;\n}\n\n.shop-hero-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(240px, 0.7fr);\n  gap: 2rem;\n  align-items: end;\n}\n\n.shop-kicker {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--secondary-gold);\n  margin-bottom: 0.65rem;\n}\n\n.shop-brand {\n  font-size: clamp(2rem, 4.5vw, 3rem);\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  line-height: 1.2;\n  margin-bottom: 0.85rem;\n}\n\n.shop-lead {\n  font-size: 1.05rem;\n  color: var(--text-medium-gray);\n  max-width: 38rem;\n  margin-bottom: 1.35rem;\n  line-height: 1.7;\n}\n\n.shop-hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.7rem;\n  margin-bottom: 0.85rem;\n}\n\n.shop-note {\n  font-size: 0.88rem;\n  color: var(--text-medium-gray);\n}\n\n.shop-hero-stats {\n  display: grid;\n  gap: 0.75rem;\n  padding: 1.25rem;\n  border: 1px solid var(--border-light);\n  background: var(--bg-white);\n  border-radius: 12px;\n}\n\n.shop-hero-stats div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding-bottom: 0.65rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.shop-hero-stats div:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.shop-hero-stats strong {\n  font-size: 1.75rem;\n  color: var(--primary-dark-blue);\n  line-height: 1;\n}\n\n.shop-hero-stats span {\n  font-size: 0.85rem;\n  color: var(--text-medium-gray);\n}\n\n.shop-wa-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 0.7rem 1.25rem;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 0.98rem;\n  text-decoration: none;\n  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.shop-wa-btn--primary {\n  background: #128c7e;\n  color: #fff;\n}\n\n.shop-wa-btn--primary:hover {\n  background: #0f766e;\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.shop-wa-btn--ghost {\n  background: transparent;\n  color: var(--primary-blue);\n  border-color: var(--border-light);\n}\n\n.shop-wa-btn--card {\n  width: 100%;\n  background: #128c7e;\n  color: #fff;\n  margin-top: auto;\n}\n\n.shop-wa-btn--card:hover {\n  background: #0f766e;\n  color: #fff;\n}\n\n.shop-toolbar {\n  position: sticky;\n  top: 70px;\n  z-index: 20;\n  padding: 0.75rem 0 1rem;\n  background: color-mix(in srgb, var(--bg-white) 94%, transparent);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.shop-toolbar-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.shop-filters,\n.shop-status-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  align-items: center;\n}\n\n.shop-chip,\n.shop-status {\n  border: 1px solid var(--border-light);\n  background: var(--section-light-gray);\n  color: var(--text-dark-gray);\n  border-radius: 999px;\n  padding: 0.4rem 0.85rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.shop-chip.is-active,\n.shop-status.is-active {\n  background: var(--primary-dark-blue);\n  border-color: var(--primary-dark-blue);\n  color: #fff;\n}\n\n.dark-mode .shop-chip.is-active,\n.dark-mode .shop-status.is-active {\n  background: var(--accent-blue);\n  border-color: var(--accent-blue);\n}\n\n.shop-search {\n  margin-inline-start: auto;\n  flex: 1 1 220px;\n  max-width: 340px;\n}\n\n.shop-search input {\n  width: 100%;\n  min-height: 42px;\n  border: 1px solid var(--border-light);\n  border-radius: 10px;\n  padding: 0.55rem 0.9rem;\n  font-family: inherit;\n  font-size: 0.95rem;\n  background: var(--bg-white);\n  color: var(--text-dark-gray);\n}\n\n.shop-grid-section {\n  padding: 1.5rem 0 3.5rem;\n}\n\n.shop-result-count {\n  font-size: 0.9rem;\n  color: var(--text-medium-gray);\n  margin-bottom: 1rem;\n}\n\n.shop-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));\n  gap: 1.2rem;\n}\n\n.shop-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-white);\n  border: 1px solid var(--border-light);\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px var(--shadow-color);\n  transition: transform 0.22s ease, box-shadow 0.22s ease;\n}\n\n.shop-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 34px var(--shadow-color);\n}\n\n.shop-card-media {\n  position: relative;\n  aspect-ratio: 1;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.shop-card-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.shop-badge {\n  position: absolute;\n  top: 0.7rem;\n  inset-inline-start: 0.7rem;\n  max-width: calc(100% - 1.4rem);\n  background: rgba(26, 54, 93, 0.92);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 0.28rem 0.55rem;\n  border-radius: 6px;\n  line-height: 1.35;\n}\n\n.shop-card--requested .shop-badge {\n  background: rgba(180, 120, 20, 0.95);\n  color: #1a202c;\n}\n\n.shop-card--inquiry .shop-badge {\n  background: rgba(74, 85, 104, 0.92);\n}\n\n.shop-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 1rem 1rem 1.15rem;\n  flex: 1;\n}\n\n.shop-card-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.shop-card-vendor {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--secondary-gold);\n  letter-spacing: 0.02em;\n}\n\n.shop-card-status {\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 0.15rem 0.45rem;\n  border-radius: 999px;\n  background: var(--section-light-gray);\n  color: var(--text-medium-gray);\n  white-space: nowrap;\n}\n\n.shop-card-status--pi {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.shop-card-status--requested {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.shop-card-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  line-height: 1.35;\n}\n\n.shop-card-model {\n  font-size: 0.82rem;\n  font-family: ui-monospace, Consolas, monospace;\n  color: var(--text-medium-gray);\n  direction: ltr;\n  text-align: start;\n}\n\n.shop-card-qty {\n  font-size: 0.84rem;\n  font-weight: 700;\n  color: var(--primary-blue);\n}\n\n.shop-card-blurb {\n  font-size: 0.88rem;\n  color: var(--text-medium-gray);\n  line-height: 1.55;\n  flex: 1;\n}\n\n.shop-protocols {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin: 0.25rem 0 0.7rem;\n  padding: 0;\n}\n\n.shop-protocols li {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.2rem 0.45rem;\n  border-radius: 5px;\n  background: var(--section-light-gray);\n  color: var(--primary-blue);\n  border: 1px solid var(--border-light);\n}\n\n.shop-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--text-medium-gray);\n}\n\n.shop-cta {\n  padding: 2.75rem 0 4rem;\n  background: var(--gradient-primary);\n  color: #fff;\n}\n\n.shop-cta-inner {\n  text-align: center;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.shop-cta h2 {\n  font-size: 1.6rem;\n  margin-bottom: 0.65rem;\n}\n\n.shop-cta p {\n  opacity: 0.95;\n  margin-bottom: 1.35rem;\n}\n\n.shop-cta .shop-wa-btn--primary {\n  background: #fff;\n  color: #0f766e;\n}\n\n.shop-cta .shop-wa-btn--primary:hover {\n  background: #f0fdfa;\n  color: #0f766e;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 860px) {\n  .shop-hero-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .shop-search {\n    margin-inline-start: 0;\n    max-width: none;\n    flex-basis: 100%;\n  }\n}\n\n@media (max-width: 640px) {\n  .shop-toolbar {\n    top: 60px;\n  }\n\n  .shop-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
